import classNames from 'classnames';
import _ from 'lodash';
import React, { memo, useRef } from 'react';
// import React, { useRef } from 'react';
import FadeIn from 'react-fade-in';
import { createUseStyles } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseCategoryClassId } from '../../utils/manager/category-manager';
import { useAnalytics } from '../../utils/setup/analytics-setup';
import { Title } from '../title';
import { Images } from './images';
import { Item } from './item';
import { ItemDivider } from './item-divider';
import { Options } from './options';
// import smoothscroll from 'smoothscroll-polyfill';

// smoothscroll.polyfill();

const propsToOmit = ['image', 'images', 'items'];

const animateFromLeft =
  'animate__animated animate__fadeInLeft animate__delay-1s';
// const animation = 'animate__animated animate__fadeInUp';
// const animateContent = 'animate__animated animate__faster animate__fadeIn';

function CategoryPrivate({
  data,
  setUpdating,
  showCartWorkflow,
  prepareCartWorkflow,
  // onClickGoBack,
  // row,
  // totalRows,
  onSpotChange,
}) {
  const { menuSlug, menuLayout, spotRef } = useStorage();
  const { analyticsHollowEvent, analyticsPageView } = useAnalytics();
  const { setOrders } = useStorage();
  const navigate = useNavigate();
  const classes = useStyles({ layout: menuLayout });

  const ref = useRef();

  const onPress = () => {
    analyticsHollowEvent('category title click');
  };

  // const handleClickGoBack = () => {
  //   analyticsFeatureUseEvent('category back to top click');
  //   onClickGoBack?.call(this);
  // };

  const onItemPress = async (category, item) => {
    try {
      await prepareCartWorkflow({ category, item });
      const { newOrder, orders, goToBill, suggestion } =
        (await showCartWorkflow()) ?? {};

      if (orders != null) {
        setOrders(orders);
      }

      if (!_.isEmpty(newOrder) && spotRef?.current?.id !== newOrder.spot.id) {
        onSpotChange(newOrder.spot);
      }

      if (suggestion != null) {
        await onItemPress(suggestion.category, suggestion.item);
      }

      if (goToBill) {
        navigate(`/${menuSlug}/conta`);
      } else {
        analyticsPageView('Menu');
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={classNames(classes.container, parseCategoryClassId(data))}>
      <div ref={ref} className={classes.spacer} />
      <div className={classes.titleContainer} onClick={onPress} aria-hidden>
        <Title className={classes.title} value={data.name} />

        {/* {row > 1 && <CategoryGoBack onClick={handleClickGoBack} />} */}
        {/* <CategoryGoBack onClick={handleClickGoBack} /> */}
      </div>
      {data.description && (
        <div
          className={classNames(classes.description, animateFromLeft)}
          style={{ '--animate-delay': '0.3s' }}
        >
          <span>{data.description}</span>
        </div>
      )}
      <Images
        data={data?.images}
        category={_.omit(data, propsToOmit)}
        onPress={onItemPress}
      />
      <FadeIn>
        <Options
          className={classes.options}
          values={_.head(data.option_groups)?.options?.filter(
            (option) => !option.blocked
          )}
          visible={data.show_options}
        />
        <div className={classes.items}>
          {data.items?.map((item, index) => (
            <div key={item.id} className={classes.item}>
              {index === 0 && <ItemDivider />}
              <Item
                data={item}
                category={_.omit(data, propsToOmit)}
                setUpdating={setUpdating}
                onPress={onItemPress}
              />
              <ItemDivider />
            </div>
          ))}
        </div>
      </FadeIn>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // borderTop: 46,
    // backgroundColor: selected => selected ? layout.cell.selectedColor : 'transparent',
    // border: '2px dashed white',
  },
  spacer: {
    height: 40,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    marginBottom: layoutDefaults.bigVerticalMargin,
    // border: "1px dashed white",
  },
  title: {
    flex: 1,
    // marginBottom: 28,
    // verticalAlign: 'middle',
    marginLeft: layoutDefaults.mainHorizontalMargin,
    marginRight: layoutDefaults.mainHorizontalMargin,
    // border: '1px dashed red',
  },
  description: {
    marginLeft: layoutDefaults.mainHorizontalMargin,
    marginRight: layoutDefaults.mainHorizontalMargin,
  },
  options: {
    marginLeft: layoutDefaults.mainHorizontalMargin,
    marginRight: layoutDefaults.mainHorizontalMargin,
    marginTop:
      layoutDefaults.verticalMargin + layoutDefaults.smallerVerticalMargin,
    marginBottom:
      layoutDefaults.verticalMargin + layoutDefaults.smallerVerticalMargin,
  },
  items: {
    marginTop: layoutDefaults.verticalMargin,
  },
  item: {
    // opacity: 0,
  },
});

const Category = memo(CategoryPrivate, _.isEqual);
// const Category = CategoryPrivate;
export { Category };
